import UI from './libs/ui'
import uniqid from 'uniqid'
var ChatbotTab = function (editor) {

    var signals = editor.signals;

    var container = new UI.Panel();
    container.setId('chatbotTab');

    //

    var selectedNode = null;

	// Voice editor default values
	const defaultVoiceIndex = 25
	const defaultVoiceVolume = 0

	// Animation editor default values
	const defaultAnimationIndex = 0


    function build() {

        container.clear();

        if (selectedNode === null) return;

		//Position of origin
		var characterPosition = selectedNode.data.selectedValues.find(selectedValue => selectedValue.key === 'characterPosition')

		var row = new UI.Row();
		row.add(new UI.Text('Position of origin').setWidth('90px'));
		container.add(row);

		var [x, y, z] = characterPosition.value

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {

			const val = this.getValue().substring(1, this.getValue().length - 1)
			const position = val.split(',').map(s => parseInt(s.trim()))
			characterPosition.value[0] = position[0]
			characterPosition.value[1] = position[1]
			characterPosition.value[2] = position[2]

		});
		row.add(input);
		container.add(row)

		//Rotation of origin
		var characterRotation = selectedNode.data.selectedValues.find(selectedValue => selectedValue.key === 'characterRotation')

		var row = new UI.Row();
		row.add(new UI.Text('Rotation of origin').setWidth('90px'));
		container.add(row);

		var [x, y, z] = characterRotation.value

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {

			const val = this.getValue().substring(1, this.getValue().length - 1)
			const rotation = val.split(',').map(s => parseInt(s.trim()))
			characterRotation.value[0] = rotation[0]
			characterRotation.value[1] = rotation[1]
			characterRotation.value[2] = rotation[2]

		});
		row.add(input);
		container.add(row)


		// Select Voice
		var characterVoice = selectedNode.data.selectedValues.find(selectedValue => selectedValue.key === 'characterVoice')

		var row = new UI.Row();
		row.add(new UI.Text('Voice Selector').setWidth('180px'));
		container.add(row);




		// start Category
		var row = new UI.Row()

		// Start gender selector
		var genderSelector = new UI.Select().setWidth('100px')
		var countrySelector = new UI.Select().setWidth('100px')

		row.add(genderSelector)
		var genders = ['Standard Male', 'Standard Female', 'Wavenet Male', 'Wavenet Female']

		// When firstly created a character, put a default gender
		if (typeof characterVoice.gender === 'undefined') {
			characterVoice.gender = 'Standard Female'
		}
		// define gender index in select menu
        // when gender is changed, automatically update countries menu list, and set the first country item as default
		var voiceGenderIndex = genders.findIndex(gender => gender === characterVoice.gender)
		genderSelector.setOptions(genders).setValue(voiceGenderIndex)
		genderSelector.onChange(function () {
			let changedVoiceGenderIndex = this.getValue()
			voiceGenderIndex = parseInt(changedVoiceGenderIndex)
			let newGender = genders[parseInt(voiceGenderIndex)]
			characterVoice.gender = newGender
			// update countries menu list
			editor.voiceCountriesNodesForChatBot = editor.voiceItems.filter(item => item.description.includes(newGender))
			editor.voiceCountriesForChatBot = editor.voiceCountriesNodesForChatBot.map(node => {
				let index = node.description.indexOf(')')
				let country = node.description.substr(0, index + 1)
				return country
			})
			editor.voiceCountriesForChatBot = _.uniq(editor.voiceCountriesForChatBot)
			countrySelector.setOptions(editor.voiceCountriesForChatBot)
			countrySelector.setValue(0)
			characterVoice.country = editor.voiceCountriesForChatBot[0]
			let nodesWithGender = editor.voiceItems.filter(item => item.description.includes(characterVoice.gender))
			let finalVoiceItem = nodesWithGender.filter(node => node.description.includes(characterVoice.country))[0]
			characterVoice.value = finalVoiceItem.audio.audioName
		})
		// End gender
        // Start Country selector
		row.add(countrySelector)
		editor.voiceCountriesNodesForChatBot = editor.voiceItems.filter(item => item.description.includes(characterVoice.gender))
		editor.voiceCountriesForChatBot = editor.voiceCountriesNodesForChatBot.map(node => {
			let index = node.description.indexOf(')')
			let country = node.description.substr(0, index + 1)
			return country
		})
		editor.voiceCountriesForChatBot = _.uniq(editor.voiceCountriesForChatBot)
		var voiceCountryIndex = editor.voiceCountriesForChatBot.findIndex(country => country === characterVoice.country)
		countrySelector.setOptions(editor.voiceCountriesForChatBot).setValue(voiceCountryIndex)
		// When firstly created a character, put a default country of US accent
		if (typeof characterVoice.country === 'undefined') {
			countrySelector.setValue(4)
			characterVoice.country = editor.voiceCountriesForChatBot[4]
		}
		countrySelector.onChange(function () {
			let changedVoiceCountryIndex = this.getValue()
			voiceCountryIndex = parseInt(changedVoiceCountryIndex)
			let newCountry = editor.voiceCountriesForChatBot[parseInt(voiceCountryIndex)]
			characterVoice.country = newCountry
			let nodesWithGender = editor.voiceItems.filter(item => item.description.includes(characterVoice.gender))
			let finalVoiceItem = nodesWithGender.filter(node => node.description.includes(characterVoice.country))[0]
			characterVoice.value = finalVoiceItem.audio.audioName
		})


		// var voiceSelector = new UI.Select()
		// let voiceIndex = editor.voiceItems.findIndex(voiceItem => voiceItem.audio.audioName === characterVoice.value)
		// voiceSelector.setOptions(editor.voiceItems.map((voiceItem, i) => voiceItem.audio.audioName)).setValue(voiceIndex);
		// voiceSelector.onChange(function (e) {

		// 	const changedVoiceSelectionIndex = this.getValue()
		// 	voiceIndex = parseInt(changedVoiceSelectionIndex)
		// 	const audioName = editor.voiceItems[parseInt(changedVoiceSelectionIndex)].audio.audioName
		// 	characterVoice.value = audioName

		// });
		// row.add(voiceSelector);
		container.add(row)

		//Enter Voice Volume
		var characterVoiceVolume = selectedNode.data.selectedValues.find(selectedValue => selectedValue.key === 'characterVoiceVolume')
		var row = new UI.Row();
		row.add(new UI.Text('Voice Volume').setWidth('180px'));
		container.add(row);

		var voiceVolume = new UI.Number(characterVoiceVolume.value).setWidth('80px');
		voiceVolume.onChange(function (e) {

			let voiceVolume = this.getValue();
			characterVoiceVolume.value = voiceVolume

		});
		row.add(voiceVolume);
		container.add(row)

		// Select Animation
		var characterAnimation = selectedNode.data.selectedValues.find(selectedValue => selectedValue.key === 'characterAnimation')
		var row = new UI.Row();
		row.add(new UI.Text('Animation Selector').setWidth('180px'));
		container.add(row);

		var animation = new UI.Select()
		let animationIndex = editor.animationItems.findIndex(animationItem => animationItem.name === characterAnimation.value)
		animation.setOptions(editor.animationItems.map((animationItem, i) => animationItem.name)).setValue(animationIndex);
		animation.onChange(function (e) {

			let changedAnimationSelectionIndex = this.getValue()
			let animationItemSelected = editor.animationItems[parseInt(changedAnimationSelectionIndex)]
			characterAnimation.value = animationItemSelected.name
		});
		row.add(animation);
		container.add(row)
	}

    signals.nodeSelected.add(function (node) {
        if (node.category === 'Chatbot') {
            selectedNode = node;
            build();
        }
    });

    return container;

};

export default ChatbotTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/ChatbotTab.js
// module id = null
// module chunks = 